import { Constants } from "../../data/constants";
import { HttpService } from "../../utils/HttpService";

export class TicketService {
  constructor() {
    this.constants = new Constants();
    this.HttpService = new HttpService();
  }
  getAllTicketsService = async (session_id) => {
    try {
      return await this.HttpService.getJson(
        this.constants.ticketServiceURLS.getTickets,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  getTicketById = async (session_id, ticketId) => {
    try {
      return await this.HttpService.getJson(
        this.constants.ticketServiceURLS.getTickets + `${ticketId}`,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };
  getTicketByCustomerId = async (session_id, customerId) => {
    try {
      return await this.HttpService.getJson(
        this.constants.ticketServiceURLS.getCustomerTickets + `${customerId}`,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  createTicket = async (
    session_id,
    ticket,
    apiUrl = this.constants.ticketServiceURLS.postTicket
  ) => {
    try {
      return await this.HttpService.postJson(
        apiUrl,
        {
          status: ticket.status,
          priority: ticket.priority,
          subject: ticket.subject,
          assignedTo: ticket.assignedTo,
          customerId: ticket.customer,
          dueDate: ticket.dueDate,
          categoryCode: ticket.categoryCode,
          comment: ticket.comment,
        },
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  deleteTicket = async (session_id, ticketId) => {
    try {
      return await this.HttpService.deleteJson(
        this.constants.ticketServiceURLS.getTickets + `${ticketId}`,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  editPriority = async (session_id, ticket) => {
    try {
      return await this.HttpService.putJson(
        this.constants.ticketServiceURLS.editPriority,
        {
          priority: ticket.priority,
          id: ticket.ticketId,
        },
        session_id
      );
    } catch (e) {
      throw e;
    }
  };
  editStatus = async (session_id, ticket) => {
    try {
      return await this.HttpService.putJson(
        this.constants.ticketServiceURLS.editStatus,
        {
          status: ticket.status,
          id: ticket.ticketId,
          changeType: "status",
          ticketId: ticket.ticketId,
          commentId: ticket.commentId,
          trackingObject: {
            action: "changed Status from ",
            userName: ticket.userName,
            prevState: ticket.prevState,
            currState: ticket.status,
          },
        },
        session_id
      );
    } catch (e) {
      throw e;
    }
  };
  editDueDate = async (session_id, ticket) => {
    try {
      return await this.HttpService.putJson(
        this.constants.ticketServiceURLS.editDueDate,
        {
          dueDate: ticket.dueDate,
          id: ticket.ticketId,
        },
        session_id
      );
    } catch (e) {
      throw e;
    }
  };
  editAssignedTo = async (session_id, ticket) => {
    try {
      return await this.HttpService.putJson(
        this.constants.ticketServiceURLS.editAssignedTo,
        {
          assignedTo: ticket.assignedTo,
          id: ticket.ticketId,
        },
        session_id
      );
    } catch (e) {
      throw e;
    }
  };
  editSubject = async (session_id, ticket) => {
    try {
      return await this.HttpService.putJson(
        this.constants.ticketServiceURLS.editSubject,
        {
          subject: ticket.subject,
          id: ticket.ticketId,
        },
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  getAllCommentsService = async (session_id, ticketNumber) => {
    try {
      return await this.HttpService.getJson(
        this.constants.ticketServiceURLS.getComments + `${ticketNumber}`,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  createComment = async (
    session_id,
    comment,
    apiUrl = this.constants.ticketServiceURLS.postComment
  ) => {
    try {
      return await this.HttpService.postJson(
        apiUrl,
        {
          content: comment.content,
          ticketNumber: comment.ticketNumber,
        },
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  deleteComment = async (session_id, commentId) => {
    try {
      return await this.HttpService.deleteJson(
        this.constants.ticketServiceURLS.getComments + `${commentId}`,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  editComment = async (session_id, comment) => {
    try {
      return await this.HttpService.putJson(
        this.constants.ticketServiceURLS.editComment,
        {
          content: comment.content,
          id: comment.id,
        },
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  getCommentsTimeLine = async (session_id, ticketId) => {
    try {
      return await this.HttpService.getJson(
        this.constants.ticketServiceURLS.getTicketTracking + `${ticketId}`,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  insertTimeline = async (session_id, trackingList) => {
    try {
      return await this.HttpService.postJson(
        this.constants.ticketServiceURLS.postTicketTracking,
        {
          changeType: trackingList.changeType,
          ticketId: trackingList.ticketId,
          commentId: trackingList.commentId,
          createdOn: trackingList.createdOn,
          trackingObject: {
            action: trackingList.trackingObject.action,
            // userName: trackingList.trackingObject.userName,
            prevState: trackingList.trackingObject.prevState,
            currState: trackingList.trackingObject.currState,
          },
        },
        session_id
      );
    } catch (e) {
      throw e;
    }
  };
}
